export default `id
name
description
updatedOn
syncedOn
deleted
templateUri`
